<template>
  <div style="background:#eee">
    <v-app v-if="selected_object.length==0" class="ma-2">
      <v-sheet>
        <v-container fluid tag="section">
          <center class="mt-12 pt-12">
            <v-icon class="mt-12" size="100" color="grey --darken-2">mdi-car-off</v-icon>
            <h3 class="pt-5">No Asset Selected</h3>
            <p class="title pt-5">Select an asset to view the asset info</p>
          </center>
        </v-container>
      </v-sheet>
    </v-app>

    <v-app
      id="ui"
      class="pa-1"
      style="background:#eee"
      fluid
      app
      tag="section"
      v-if="selected_object.length > 0"
    >
      <v-overlay
        :absolute="false"
        :opacity="0.45"
        :value="fetching_data"
        :z-index="3939938498494989"
      >
        <v-skeleton-loader
          :transition="'scale-transition'"
          height="94"
          width="350"
          type="list-item"
          class="loader"
        ></v-skeleton-loader>
      </v-overlay>

      <v-container id="dashboard" fluid tag="section">
        <v-toolbar
          dark
          v-bind:color="!objectsOnly[0]?.engineon? 'grey lighten-1':'green lighten-1'"
        >
          <v-toolbar-title>
            <h3 class="font-weight-light">
              <span>
                <v-icon large>mdi-truck</v-icon>
              </span>
              {{  objectsOnly[0]?.name }}
            </h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <small>({{ !objectsOnly[0]?.engineon? 'Engine Off':'Engine On' }})</small>
        </v-toolbar>
        <v-tabs color="orange" v-model="tabs">
          <br />
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#movements" @click="page=1">
            <v-icon>mdi-map-marker-path</v-icon>
            <small class="px-3">Movements</small>
          </v-tab>

          <v-tab href="#stops" @click="page=1">
            <v-icon>mdi-car-brake-parking</v-icon>
            <small class="px-3">Stops</small>
          </v-tab>

          <v-tab href="#alerts" @click="page=1">
            <v-icon>mdi-alert-remove-outline</v-icon>
            <small class="px-3">Alerts</small>
          </v-tab>

          <v-tab href="#map" @click="page=1">
            <v-icon>mdi-map</v-icon>
            <small class="px-3">View On Map</small>
          </v-tab>  
        </v-tabs>

         <v-sheet elevation="1" class="pa-4 mb-4 rounded-lg" color="white">
          <v-row align="center" dense> 
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="selected_asset"
                :items="all_assets"
                item-text="name"
                item-value="imei"
                label="Select Vehicle"
                prepend-inner-icon="mdi-car-connected"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                ref="menuFrom"
                v-model="menuu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="from_date"
                    label="From Date"
                    prepend-inner-icon="mdi-calendar-start"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" @input="menuu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="To Date"
                    prepend-inner-icon="mdi-calendar-end"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="3" class="d-flex">
              <v-btn 
                color="blue" 
                dark 
                block 
                height="40"
                @click="available_data"
                :loading="fetching_data"
              >
                <v-icon left>mdi-magnify</v-icon>
                Search Records
              </v-btn>
            </v-col>

          </v-row>
        </v-sheet>

      <div v-if="top_dash.length > 1" class="mb-2">
        <v-row dense>
          <v-col cols="6" sm="4" lg="2" v-for="item in top_dash" :key="item.title">
            <base-stat-tile
              :title="item.title"
              :value="item.value"
              :icon="item.icon"
              :accent="item.accent"
            />
          </v-col>
        </v-row>
      </div>

        
 
            <v-tabs-items v-model="tabs" v-if="!fetching_data" style="background: #eee"> 
            <v-tab-item :value="'movements'">
              <div v-if="!fetching_data && trip_data.drives.length==0">
          <br>
             <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
               <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
               </v-alert>  
        </div>
              <v-alert v-for="(drive,i) in filterrable(trip_data.drives)" :key="i" border="left" :color="drive[8]>60?'red accent-4':'blue accent-4'" colored-border  elevation="0" > 
              <div><v-icon>mdi-map-marker-distance</v-icon> <span class="px-3 display-1 font-weight-light"> {{drive[15].from}} <b class="orange--text">-</b> {{drive[15].to}}</span>   </div> 
              <div class="body-1  font-weight-light py-2"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[6]}}  <small class="px-4">({{drive[4]}} - {{drive[5]}})</small></div>
              <div class="body-1  font-weight-light py-1"><v-icon>mdi-road-variant</v-icon> <i class="px-2"></i>{{drive[7] +" km"}}</div>
              <div class="body-1  font-weight-light py-1"><v-icon>mdi-fuel</v-icon> <i class="px-2"></i>{{drive[10] +" ltr"}}</div>
              <div class="row py-1 ml-1">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-speedometer</v-icon> <i class="px-2"></i>{{drive[8] +" kph"}} <small class="px-4">(Top Speed)</small> <i class="px-2"></i>{{drive[9] +" kph"}} <small class="px-4">(Average trip Speed)</small></div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="openPlayback(drive)"><small>Playback</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.drives.length>page_size" :length="round(trip_data.drives.length/page_size)"></v-pagination>
            </v-tab-item>

            <v-tab-item :value="'stops'"> 
               <div v-if="!fetching_data &&   trip_data.stops.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle movement records available.</div> 
                    </v-alert>  
              </div>

              <v-alert border="left" color="blue-grey accent-2"  v-for="(drive,i) in filterrable(trip_data.stops)" :key="i" colored-border  elevation="0" > 
              <div class="display-1  font-weight-light"><v-icon>mdi-google-maps</v-icon> <i class="px-2"></i>{{drive[13]}}</div> 
               <div class="row py-3 ml-0">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[8]}}  <small class="px-4">({{drive[6]}} - {{drive[7]}})</small></div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="showMap(drive,'stops')"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.stops.length>page_size" :length="round(trip_data.stops.length/page_size)"></v-pagination>
            </v-tab-item>

            <v-tab-item  :value="'alerts'">
               <div v-if="alerts_capped" class="text-caption grey--text pt-2">
                 Alerts are limited to the last 2 days of the selected range.
               </div>
               <div v-if="!fetching_data &&   trip_data.events.length==0">
                <v-alert border="left" color="blue-grey accent-2" colored-border type="info"  elevation="2" > 
                    <div class="display-1  font-weight-light">No vehicle alert records available.</div> 
                    </v-alert>  
              </div> 

              <v-alert v-for="(drive,i) in filterrable(trip_data.events)" :key="i" border="left" color="red accent-4" colored-border  elevation="0" >
                <div><v-icon>mdi-map-marker-distance</v-icon> <span class="px-3 display-1 font-weight-light"> {{drive[0]}} <b class="orange--text">-</b> {{drive[8]}}</span>   </div> 
              <div class="body-1  font-weight-light py-2"><v-icon>mdi-clock-time-two-outline</v-icon> <i class="px-2"></i>{{drive[1]}} </div>  
               <div class="row py-3 ml-0">
                <div cols="10" class="body-1  font-weight-light"><v-icon>mdi-speedometer</v-icon> <i class="px-2"></i>{{drive[6] +" kph"}}</div>
                <div cols="2" class="body-1  font-weight-light"> <v-btn class="ml-10" small outlined @click="showMap(drive,'alert')"><small>View On Map</small></v-btn></div>
              </div>
              </v-alert> 
              <v-pagination v-model="page" v-if="trip_data.events.length>page_size" :length="round(trip_data.events.length/page_size)"></v-pagination>
            </v-tab-item>

              <v-tab-item :value="'map'">
                <div style="min-height: 300px">
                    <Map :tracking_data="tracking_data" />
                </div> 
            </v-tab-item> 
          </v-tabs-items> 

        <div>  
        </div>
      </v-container>
 
    </v-app>
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import common from "../mixins/common";
import kensrin_map from "../mixins/kensrin_map";
import Map from "../account/Map" 
import { searchAssets } from "@/services/assetsDb";
import { fetchTripReport, fetchRoutePoints, watchTripReport, fetchAlerts } from "@/services/nodeReports";

export default {
  name: "Trips",
  mixins: [common ],
  components:{ Map },
  computed: {
    ...mapState(["notification", "session", "selected_object"]),
    // The asset actually being searched: the dropdown selection wins, falling
    // back to the globally-selected asset.
    activeImei() {
      return this.selected_asset || (this.selected_object && this.selected_object[0]) || null;
    },
    // The server only geocodes the last 2 days of alerts, so flag a wider range.
    alerts_capped() {
      return moment(this.date).diff(moment(this.from_date), "days", true) > 2;
    }
  },
  data() {
    return {
      all_assets: [],
      selected_asset: "",
      objectsOnly: [],
      asset_groups: [],
      top_dash: [],
      m_notification: [],
      trip_data: {
        drives: [],
        events: [],
        stops: []
      },
      tracking_data: [{lat:1.1, lng: 1.1, speed: 200, engineon: true}],
      from_date: moment().subtract(1,'days').format("YYYY-MM-DD"),  //
      date: new Date().toISOString().substr(0, 10), 
      fetching_data: false,
      fetching_trip: false,
      report_watcher: null,
      page: 1, 
      page_size: 10,
      menu: false,
      menuu: false,
      modal: false,
      tabs: null, 
    };
  },
  created() {
    // Initial load happens in mounted, once the asset list is available.
  },
  async mounted() {   
    this.all_assets = await searchAssets(this.session.account[0].username);
    this.selected_asset = this.selected_object[0] || null;
  },
  beforeDestroy() {
    if (this.report_watcher) this.report_watcher();
  },
  methods: {
    filterrable(array){
      var new_array = [];  
      for(var i = this.page_size * (this.page -1); i < this.page * this.page_size; i++ ){
        if(i>=array.length)
          break;
        new_array.push(array[i]); 
      } 
      return new_array;
    },
    round(data){
      return Math.ceil(data);
    },
 
    showMap(data,source){ 
      if(source=="stops"){
        this.tracking_data = [];
        this.tracking_data.push({lat: data[2],lng: data[3],speed: 0,engineon: false,current_loc: data[13],dt_tracker: data[8] });
        this.tabs ="map";
      } else if(source == "alert"){  
        this.tracking_data = []; 
        this.tracking_data.push({lat: data[2],lng: data[3],speed: data[6],engineon: true,current_loc: data[8],dt_tracker: data[1] });
        this.tabs ="map"; 
      }
    },

    async fetch_drive(trip){
      this.fetching_trip = true;
      this.tracking_data = [];  
      // kensrin_server only — no PHP fallback.
      const res = await fetchRoutePoints({
        imei: this.activeImei,
        dtf: trip[4],
        dtt: trip[5]
      });
      this.fetching_trip = false;
      if (res.status == 200 && Array.isArray(res.data)) {
        res.data.map(c=>{  
          this.tracking_data.push({lat: c[1],lng: c[2],speed: c[5],engineon: true,current_loc: c[7],dt_tracker: c[0] });
        });
        this.tabs = "map";
      }
    },

    // Open the Playback view for this trip's asset and time window.
    // drive[4]/drive[5] are the trip's start/end "YYYY-MM-DD HH:mm" strings.
    openPlayback(drive) {
      const start = String(drive[4] || "");
      const end = String(drive[5] || "");
      this.$router.push({
        name: "Playback",
        query: {
          imei: this.activeImei,
          dateFrom: start.slice(0, 10),
          timeFrom: start.slice(11, 16),
          dateTo: end.slice(0, 10),
          timeTo: end.slice(11, 16)
        }
      });
    },

    async available_data() { 
      this.top_dash =[]; 
      this.fetching_data = true;
      // Clear stale rows for the new asset/range; apply_report/load_alerts refill them.
      this.trip_data = { drives: [], events: [], stops: [] };
      try {
        // kensrin_server only — no PHP fallback.
        const res = await fetchTripReport({
          imei: this.activeImei,
          from: this.date,
          to: this.date
        });

        if (res.status == 200) {  
          this.apply_report(res.data);
          this.watch_summary_updates();
        }
        // Alerts are not part of the trips payload (the server sends events: []),
        // so fetch them straight from /get_alerts for the Alerts tab.
        await this.load_alerts();
      } catch (err) {
        this.fetching_data = false;
      } finally {
        this.fetching_data = false;
      }
    },

    // Alerts for the selected range, mapped to the positional row shape the
    // alerts template and showMap() expect:
    //   [0] description, [1] datetime, [2] lat, [3] lng, [6] speed, [8] location
    async load_alerts() {
      if (!this.activeImei) return;
      const res = await fetchAlerts({
        imei: this.activeImei,
        from: this.from_date,
        to: this.date
      });
      if (res.status !== 200) return;
      this.trip_data.events = (res.data || []).map((h) => {
        const ev = [];
        ev[0] = h.event_desc || h.name || "Alert";
        ev[1] = h.dt_tracker;
        ev[2] = Number(h.lat);
        ev[3] = Number(h.lng);
        ev[6] = Number(h.speed) || 0;
        ev[8] = h.loc || "";
        return ev;
      });
    },

    // Renders one report payload: the summary tiles plus the trip table.
    apply_report(data) {
      this.top_dash = [];
      // The template reads trip_data.drives/stops/events everywhere, so make
      // sure every array exists even if the payload omits one. `events` is not
      // part of the trips payload (the server sends events: []) - it is filled
      // by load_alerts(), so keep what we fetched instead of letting the empty
      // payload array clobber it (apply_report also runs on summary polls).
      this.trip_data = {
        drives: [],
        stops: [],
        ...data,
        events: this.trip_data.events || []
      };
      this.top_dash.push({
        title: "Hours Moved",
        value: data.drives_duration,
        icon: "mdi-timer-outline",
        accent: "#7c4dff"
      });
      this.top_dash.push({
        title: "Distance Covered",
        value: data.route_length.toLocaleString() + " km",
        icon: "mdi-map-marker-distance",
        accent: "#2962ff"
      });
      this.top_dash.push({
        title: "Fuel Consumed",
        value: data.fuel_consumption.toLocaleString() + " ltr",
        icon: "mdi-fuel",
        accent: "#00bfa5"
      });
      this.top_dash.push({
        title: "Average Speed",
        value: data.avg_speed + " kph",
        icon: "mdi-speedometer",
        accent: "#ff9100"
      });
      this.top_dash.push({
        title: "Top Speed",
        value: data.top_speed + " kph",
        icon: "mdi-trending-up",
        accent: "#ff3d71"
      });
      this.top_dash.push({
        title: "Hours Parked",
        value: data.stops_duration,
        icon: "mdi-car-brake-parking",
        accent: "#00b8d4"
      });
    },

    // The summaries behind this report are built by the aggregator worker, so an
    // early reply can still be catching up. Keep re-asking and refresh in place
    // until the API reports the summaries are current.
    watch_summary_updates() {
      const self = this;
      if (this.report_watcher) {
        this.report_watcher();
        this.report_watcher = null;
      }
      this.report_watcher = watchTripReport(
        {
          imei: this.activeImei,
          from: this.date,
          to: this.date
        },
        function (data) {
          self.apply_report(data);
        }
      );
    }
  },
  watch: {
    // Picking an asset in the dropdown searches that asset.
    selected_asset() {
      this.page = 1;
      if (!this.activeImei) return;
      this.available_data();
    },
    "$store.state.selected_object": function() {
      this.tracking_data = [];
      this.tabs = "movements";
      const next = this.selected_object[0] || null;
      if (next !== this.selected_asset) this.selected_asset = next;
      else this.available_data();
    }
  }
};
</script>

<style scoped>
#dashboard,
template {
  background: #e7e7e7;
}
</style>
